export default __webpack_public_path__ + "static/media/Heather.6aae1e16.jpg";